module.exports = __webpack_public_path__ + "img/what'snew-locked.b015ec95.svg";